<!--发布课程管理-->
<template>

  <div >
    <el-form  ref="registerRef"  :model="createParam" :rules="rules" label-width="150px">
      <el-form-item  label="卡名称:"  prop="name">
        <el-input style="width: 300px" v-model="createParam.name" placeholder="输入卡名称"></el-input>
      </el-form-item>
      <el-form-item  label="卡描述:" >
        <el-input style="width: 300px"  v-model="createParam.descripe" placeholder="输入卡描述"></el-input>
      </el-form-item>
      <el-form-item  label="价值(元):" prop="valueMoney">
        <el-input-number v-model="createParam.valueMoney"></el-input-number>
      </el-form-item>
      <el-form-item  label="卡有效时长(天):"  prop="validDays">
        <el-input-number v-model="createParam.validDays"></el-input-number>
      </el-form-item>
      <el-form-item  label="版本:"  prop="optionsLessonValue" >
        <el-select v-model="createParam.optionsLessonValue" placeholder="请选择版本" @change="changeLessonTemplate">
          <el-option
            v-for="item in storeLessons"
            :key="item.id"
            :label="item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="卡子业务类型:"  prop="cardSubTypeId">
        <el-select v-model="createParam.cardSubTypeId" clearable placeholder="请选择子业务类型">
          <el-option
            v-for="item in subCardTypes"
            :key="item.id"
            :label="item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="卡使用类型:" prop="useType">
        <el-select v-model="createParam.useType" placeholder="请选择卡使用类型">
          <el-option
            v-for="item in cardUseTypeList"
            :key="item.v"
            :label="item.des"
            :value="item.v">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="计费类型:"  prop="optionsValue">
        <el-select v-model="createParam.optionsValue" placeholder="请选择">
          <el-option
            v-for="item in createParam.options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="正价课时:"  prop="totalClassCount">
        <el-input-number v-model="createParam.totalClassCount"></el-input-number>
      </el-form-item>
      <el-form-item  label="赠送课时:"  prop="giveClassCount">
        <el-input-number v-model="createParam.giveClassCount"></el-input-number>
      </el-form-item>
      <!--<el-form-item  label="开卡积分">-->
        <!--<el-input-number v-model="createParam.points"></el-input-number>-->
      <!--</el-form-item>-->
      <el-form-item  label="启用状态:" prop="optionsUseValue">
        <el-select v-model="createParam.optionsUseValue" placeholder="请选择">
          <el-option
            v-for="item in createParam.optionsUse"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>



    </el-form>

  </div>
</template>

<style>

</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import enumsUtil, {ECardUseType} from "../../../utils/enumsUtil";
  import commonUtils from "../../../utils/commonUtils";
  import {getCardSubTypeList,} from "../../../api/StoreLessonCard";
  export default {
    name: 'NewStoreLessonCardInfo',
    props: {
      isExp : Number, //是否是体验卡
      storeLessons:Array,
    },
    data() {
      return {
        createParam :{
        },
        rules:{
          name:[{required:true,message:"请输入卡名称",trigger:"blur"}],
          descripe:[{required:true,message:"请输入卡描述",trigger:"blur"}],
          storeLessonCardTemplateId:[{required:true,message:"请选择业务类型",trigger:"blur"}],
          useType:[{required:true,message:"请选择使用类型",trigger:"blur"}],
          optionsValue:[{required:true,message:"请选择计费类型",trigger:"blur"}],
          totalClassCount:[{required:true,message:"请输入正价课时",trigger:"blur"}],
          valueMoney:[{required:true,message:"请输入价格",trigger:"blur"}],
          optionsUseValue:[{required:true,message:"请选择启用状态",trigger:"blur"}],
          optionsLessonValue:[{required:true,message:"请选择业务类型",trigger:"blur"}],
          validDays:[{required:true,message:"请选择卡有效时长",trigger:"blur"}],
        },
        cardUseTypeList:ECardUseType(),
        subCardTypes:[],
      }
    },
    created(){
      this.initData();

    },

    mounted() {
     
    },
    methods: {
      initData(){
        this.createParam ={
          name: '',
          descripe:'',
          storeLessonCardTemplateId:'',
          storeFrontId:'',
          storeLessonId:"",
          validDays: '' ,
          totalClassCount:0,
          giveClassCount:0,
          valueMoney:'',
          createAdminId :"",
          consumeType:'',
          statu :"",
          storeLessonIdDes:'',
          createAdminName :"",
          statuDes:'',
          consumeDes:'',
          cardSubTypeId:'',
          options: [{
            value: '0',
            label: '按次'
          }],
          optionsValue: '',
          optionsLesson: [{
            id: '0',
            name: '基础游'
          }],
          optionsLessonValue:"",
          optionsUse: [{
            value: 0,
            label: '启用'
          },
            {
              value: 1,
              label: '禁用'
            }],
          optionsUseValue:0,
          points:0,
          useType:0,
        };

      },
      getstoreLesson(lessonTemplateId){
        for (let i = 0;i<this.storeLessons.length;++i){
          if (this.storeLessons[i].id == lessonTemplateId) {
            return this.storeLessons[i];
          }
        }
      },
      changeLessonTemplate(val){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          storeLessonCardTemplateId:val
        }
        this.subCardTypes=[]
        this.createParam.cardSubTypeId=''
        getCardSubTypeList(param).then(response =>
          {
            let data = response.data;
            if (commonUtils.isObjectNull(data)){
              return;
            }
            for (let i = 0;i< data.length;++i){
              let option = {
                id:data[i].id,
                type:data[i].name,
              }
              this.subCardTypes.push(option);
            }

          })
      },
      getCardInfo(callBack ){

        this.$refs['registerRef'].validate((valid) => {

          if (valid) {
            let storeLessonId = this.getstoreLesson(this.createParam.optionsLessonValue).storeLessonId;

            let info = {
              storeFrontId:globaldata.getAdminStore().storeFrontId,
              name: this.createParam.name,
              descripe: this.createParam.descripe,
              storeLessonCardTemplateId:this.createParam.optionsLessonValue,
              storeLessonId:storeLessonId,
              validDays: this.createParam.validDays,
              totalClassCount:this.createParam.totalClassCount,
              giveClassCount:this.createParam.giveClassCount,
              valueMoney:this.createParam.valueMoney,
              createAdminId :globaldata.getAdminStore().id,
              consumeType:this.createParam.optionsValue,
              statu :this.createParam.optionsUseValue,
              points:this.createParam.points,
              experience: this.isExp,
              useType:this.createParam.useType,
              cardSubTypeId:this.createParam.cardSubTypeId,
            }

            if (callBack){

              callBack(info);
            }

            return info;

          } else {
            if (callBack){
              callBack(false);
            }

            return false
          }
        });


      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/store-lesson-card/components/NewStoreLessonCardInfo.vue